/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  if($(window).width() < 990){
    if($(window).width() > 749 && $(window).width() < 990){
      var w = $(window).width() - 44;
    }else if($(window).width() < 750){
      var w = $(window).width() - 32;
    }
    $("iframe[title='YouTube video player']").width(w);
    $("iframe[title='YouTube video player']").height(w/16*9);
  }
})();

$(window).resize(function(){
  if($(window).width() < 990){
    if($(window).width() > 749 && $(window).width() < 990){
      var w = $(window).width() - 44;
    }else if($(window).width() < 750){
      var w = $(window).width() - 32;
    }
    $("iframe[title='YouTube video player']").width(w);
    $("iframe[title='YouTube video player']").height(w/16*9);
  }else{
    var yt = $("iframe[title='YouTube video player']").attr("width");
    $("iframe[title='YouTube video player']").width(yt);
    $("iframe[title='YouTube video player']").height(yt/16*9);
  }
});

$(document).ready(function(){
  $('.blog-listing__slider').slick({
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  document.addEventListener('rebuy:cart.change', (event) => { 
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
          $(".header__cart__status").text(cart.item_count);
          $(".header__cart__status").attr("data-cart-count", cart.item_count);
        }
    });
  });
});